<div
 *ngIf="hasPermissionToAddOpinions"
  class="bg-white btn-group"
  data-test-selector="opinion-section"
>
  <button
    class="btn btn-default border-secondary btn-xs"
    data-test-selector="current-product-button"
    [ngClass]="opinion === crossVizientOpinionEnum.APPROVED ? 'btn-secondary' : 'text-gray-600'"
    (click)="toggleApprovedVoteClick()"
  >
    <i [ngClass]="opinion === crossVizientOpinionEnum.APPROVED ? 'fas' : 'far' "  class="mx-1 fa-star"></i>
  </button>

  <button
    class="btn btn-default border-secondary btn-xs"
    data-test-selector="unacceptable-button"
    [ngClass]="opinion === crossVizientOpinionEnum.DENIED ? 'btn-secondary' : 'text-gray-600'"
    (click)="toggleDeniedVoteClick()"
  >
  <i class="mx-1 far fa-solid fa-ban"></i>
  </button>
</div>

<div
 *ngIf="!hasPermissionToAddOpinions"
 class="text-gray-600 fw-bold"
 data-test-selector="opinion-view"
>
  <div *ngIf="opinion === crossVizientOpinionEnum.APPROVED">
    <i class="mx-1 fas fa-star"></i>
    Approved
  </div>
  <div *ngIf="opinion === crossVizientOpinionEnum.DENIED">
    <i class="mx-1 far fa-solid fa-ban"></i>
    Denied
  </div>
</div>
